import React from 'react'
import Link from 'next/link'
import { Trans } from '@lingui/macro'

export default function AccountOptions() {
  return (
    <Link href="/authentication/access" className="block text-white bg-transparent hover:bg-gray-200 hover:bg-opacity-50 active:bg-gray-200 cursor-pointer border border-gray-300 text-gray-600 text-xs sm:text-sm p-2 rounded-md">
      <span className="text-gray-700 text-xs xl:text-sm font-semibold leading-none">
        <Trans>Acceder</Trans>
      </span>
    </Link>
  )
}
